module.exports = __webpack_public_path__ + "img/lv18.5f6b5e3e.png";